import React from "react";
import Grid from "@mui/material/Grid";
import useStyles from "./landingStyle-jss";
import Title from "./Title";
import sson from "../../images/services/sso-new.webp";
import vlabs from "../../images/services/vlabs.webp";
import cdac from "../../images/services/service.webp";
import "./Landing.css";
import Programms from "./Programms";
import Confrence from "./Confrence";
import LatestNews from "./LatestNews";

const UpcomingActivity = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  return (
    <div className="my-5">
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="Recent Activities"
          // desc="Integrated all your services at one platform"
          align="center"
          monocolor={slideMode && true}
        />
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Programms />
          </Grid>
          <Grid item md={4}>
            <Confrence />
          </Grid>
          <Grid item md={4}>
            <LatestNews />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default UpcomingActivity;
